import LocalForage from 'localforage'
import LocalDatabase from './utils/LocalDatabase'
import router from './router'
import store from './store/index'
import Types from './store/types'
import moment from 'moment'
/*
Configure localforage
*/
LocalForage.config({
  driver: LocalForage.INDEXEDDB,
  name: 'ICT Cell, CU',
  version: 4,
  storeName: 'vue-base-cli3'
})

async function updateStoreForHardReload() {
  // console.log('.::. Hard Reload .::.')
  const access_token = await LocalDatabase.get(Types.localdb.USER_TOKEN)
  const role = await LocalDatabase.get(Types.localdb.USER_ROLE)
  const user = await LocalDatabase.get(Types.localdb.USER)
  const expires_in = await LocalDatabase.get(Types.localdb.EXPIRES_IN)

  const gce_access_token = await LocalDatabase.get(Types.localdb.GCE_USER_TOKEN)
  const gce_expires_in = await LocalDatabase.get(Types.localdb.GCE_EXPIRES_IN)
  const gce_user = await LocalDatabase.get(Types.localdb.GCE_USER)

  if (gce_access_token) {
    if (!gce_expires_in || gce_expires_in < moment().unix()) {
      await store.dispatch(Types.actions.UPDATE_GCE_AUTH_RESET)
      return {
        redirect: true
      }
    }
    await store.dispatch(Types.actions.UPDATE_GCE_USER_TOKEN, {
      access_token: gce_access_token,
      expires_in: gce_expires_in,
      ...gce_user
    })
  }

  if (access_token) {
    if (!expires_in || expires_in < moment().unix()) {
      await store.dispatch(Types.actions.UPDATE_AUTH_RESET)
      return {
        redirect: true
      }
    }
    await store.dispatch(Types.actions.UPDATE_USER_TOKEN, {
      access_token,
      role,
      user,
      expires_in
    })
  } else {
    await store.dispatch(Types.actions.UPDATE_AUTH_RESET)
    // return {
    //   redirect: true
    // }
  }
  // console.log('access token ::', access_token)
}
updateStoreForHardReload()
  .then(function (data) {
    require('./init')
    if (data && data.redirect) {
      router.push({
        name: 'home'
      })
    }
  })
  .catch(error => {
    console.log(error)
  });


// Now the app is initialized after store is updated
